import React from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'

import UnsignedLayout from 'ui/layouts/Unsigned'
import SignedInLayout from 'ui/layouts/SignedIn'
import DefaultLayout from 'ui/layouts/Default'
import ErrorLayout from 'ui/layouts/Error'
import ProtectedRoute from 'routes/ProtectedRoute'

import Login from 'ui/views/Login'
import Home from 'ui/views/Home'
import Sms from 'ui/views/Sms'
import Dashboard from 'ui/views/Dashboard'

import Quiz from 'ui/views/Quiz'
import QuizFail from 'ui/views/Quiz/Fail'
import QuizFinished from 'ui/views/Quiz/Finished'
import Result from 'ui/views/Result'
import Email from 'ui/views/Email'
import Fail from 'ui/views/Fail'
import ServiceSelection from 'ui/views/ServiceSelection'
import Success from 'ui/views/Success'
import Users from 'ui/views/User'
import Blocked from 'ui/views/Blocked'
import RecoverPassword from 'ui/views/RecoverPassword'
import RecoverPasswordForm from 'ui/views/RecoverPasswordForm'


export default () => {
  return (
    <Switch>
      <UnsignedLayout exact path="/" component={Login} />
      <UnsignedLayout exact path="/login" component={Login} />
      <UnsignedLayout exact path="/login/recover"  component={RecoverPassword} />
      <UnsignedLayout exact path="/login/recoverForm"  component={RecoverPasswordForm} />

      <ProtectedRoute path="/home" parent={DefaultLayout} child={Home} />
      <ProtectedRoute path="/service/selection/:requestId" parent={DefaultLayout} child={ServiceSelection} />
      <ProtectedRoute path="/email/:requestId" parent={DefaultLayout} child={Email} />
      <ProtectedRoute path="/sms/:requestId" parent={DefaultLayout} child={Sms} />
      <ProtectedRoute
        path="/quiz/:requestId/fail"
        parent={DefaultLayout}
        child={QuizFail}
      />
      <ProtectedRoute
        path="/quiz/:requestId/finished"
        parent={DefaultLayout}
        child={QuizFinished}
      />


      <ProtectedRoute path="/quiz/:requestId" parent={DefaultLayout} child={Quiz} />
      <ProtectedRoute path="/success" parent={DefaultLayout} child={Success} />
      <ProtectedRoute path="/users" level="admin" parent={SignedInLayout} child={Users} />
      <ProtectedRoute path="/dashboard/blocked" level="admin" parent={SignedInLayout} child={Blocked} />


      <ProtectedRoute path="/result" parent={DefaultLayout} child={Result} />

      <ErrorLayout path="/fail" component={Fail} />

      <ProtectedRoute
        path="/dashboard"
        parent={SignedInLayout}
        child={Dashboard} />


      <Route default render={() => (
        <Redirect to="/login" />
      )} />
    </Switch>
  )
}
